export enum ProductCostUnit {
	PERCENT = 'Percent',
	AMOUNT = 'Amount',
}
